import {
    GET_SKULOOKUP_REPORT_REQUEST,
    GET_SKULOOKUP_REPORT_SUCCESS,
    GET_SKULOOKUP_REPORT_ERROR,
  } from "../actions/types";
  
  export const getSKULookUpReport = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case   GET_SKULOOKUP_REPORT_REQUEST:
        return {
          loading: true,
        };
      case   GET_SKULOOKUP_REPORT_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case   GET_SKULOOKUP_REPORT_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  